var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{staticClass:"title is-4"},[_vm._v("Data dumps")]),_vm._v("  "),_c('br'),_c('br'),_c('button',{staticClass:"button is-fullwidth is-primary",on:{"click":function($event){return _vm.$router.push({ name: 'create-data-dump' })}}},[_vm._v(" Upload nieuwe data dump ")]),_c('br'),_c('datadumpTable',{attrs:{"dumps":_vm.datadumps}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }